import { IBlowDef } from './types';
import { seg } from './segments';

/** Unused / broken / deprecated / marker / nonexistent-in-engine blow entries. */
export const markers: Record<number, IBlowDef> = {
    46: {
        name: '(unimplemented)',
        status: 'unused',
        wikiDesc: 'No effect.',
    },
    101: { name: 'Ab Melee PDefense', status: 'unused', wikiDesc: 'Unused.' },
    102: { name: 'Rt Melee PDefense', status: 'unused', wikiDesc: 'Unused.' },
    103: { name: 'Ab Ranged PDefense', status: 'unused', wikiDesc: 'Unused.' },
    104: { name: 'Rt Ranged PDefense', status: 'unused', wikiDesc: 'Unused.' },
    105: { name: 'Ab Melee MDefense', status: 'unused', wikiDesc: 'Unused.' },
    106: { name: 'Rt Melee MDefense', status: 'unused', wikiDesc: 'Unused.' },
    107: { name: 'Ab Ranged MDefense', status: 'unused', wikiDesc: 'Unused.' },
    108: { name: 'Rt Ranged MDefense', status: 'unused', wikiDesc: 'Unused.' },
    183: {
        name: 'Ignore Prefix Skill',
        status: 'marker',
        wikiDesc: 'Marker: prefix/dragon gem on-hit proc blows do not fire while applied (ghoul mode).',
    },
    184: {
        name: 'FD Buff (PATK)',
        status: 'deprecated',
        wikiDesc: 'Old FD buff for PATK; no longer works.',
        note: 'Use 389 instead.',
    },
    185: {
        name: 'FD Buff (MATK)',
        status: 'deprecated',
        wikiDesc: 'Old FD buff for MATK; no longer works.',
        note: 'Use 389 instead.',
    },
    212: {
        name: 'Add State on Timer',
        status: 'unused',
        wikiDesc: 'Unused. Every Interval ms, Chance to apply a state effect to all enemies within Range.',
        note: 'Applied blow is hardcoded to 42 (Burn) for 5000ms, ignoring BlowIndex/Duration params.',
    },
    246: {
        name: 'Stigma',
        status: 'marker',
        wikiDesc: 'Marker: projectiles with TargetStateIndex set home in on marked actors, and marked ' +
            "actors get an on-screen marker. Only the caster's newest mark survives; the mark is " +
            'removed if the marked actor lands a hit on the caster.',
        note: 'Required by Puppet (247).',
    },
    257: {
        name: 'Move Speed Increase',
        status: 'unused',
        wikiDesc: 'Unused (intended town move speed).',
    },
    258: {
        name: 'Vehicle Move Speed',
        status: 'unused',
        wikiDesc: 'Unused (intended mount move speed).',
    },
    267: {
        name: 'Add Critical Rate',
        status: 'broken',
        wikiDesc: 'Applies a 0-value, 0-duration buff (no effect).',
        note: "Don't use.",
    },
    268: {
        name: 'Damage Change',
        status: 'broken',
        wikiDesc: 'Never triggers; has no effect.',
        note: "Don't use.",
    },
    303: {
        name: '(does not exist)',
        status: 'unused',
        wikiDesc: 'Not a real state effect; there is no 303 in the engine.',
    },
    308: {
        name: 'Cannot be targeted by autotargeting',
        status: 'marker',
        wikiDesc: 'Marker: excluded from guided arrow / range checker target scans and bouncing ' +
            'projectile target selection (guided missile, ping pong, etc).',
    },
    342: {
        name: 'Unused',
        status: 'unused',
        wikiDesc: 'Unused.',
    },
    347: {
        name: 'Bubble-related marker skill',
        status: 'marker',
        wikiDesc: 'Used as a marker for certain bubble skills; does nothing on its own.',
        describe() {
            return ['Marks the target (used as a marker by certain bubble skills, e.g. BFP); has no ' +
                'effect on its own'];
        },
    },
    359: {
        name: '(unimplemented)',
        status: 'unused',
        wikiDesc: 'No effect.',
    },
    363: {
        name: 'Heat Haze',
        status: 'broken',
        wikiDesc: 'Heat haze screen distortion filter, intended to take power;speed params.',
        note: "Broken: does nothing. Don't use.",
    },
    374: {
        name: 'Unused',
        status: 'unused',
        wikiDesc: 'Unused.',
    },
    392: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    393: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    394: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    395: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    396: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    397: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    398: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    399: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    400: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    401: { name: 'Marker (no effect)', status: 'marker', wikiDesc: 'Marker: no effect.' },
    409: {
        name: 'Marker (no effect) at random chance',
        status: 'marker',
        wikiDesc: 'Marker with no effect of its own, applied at a random chance (Rate). Used by ' +
            'slayer projectiles.',
        describe({ params }) {
            const rate = params.nextNum();
            if (isNaN(rate)) {
                return null;
            }
            return [
                'Marker (no effect); applied at rate ', seg.num(rate), ' (used by slayer projectiles)',
            ];
        },
    },
    417: {
        name: 'Slot Amplify Effect 1',
        status: 'marker',
        wikiDesc: 'Marker for amplify slot 1 of the EX Source slot system: while applied, the ' +
            "equipped Source EX potential's skill level-up value takes effect for that slot.",
        note: 'Level amount comes from the Source EX potential skill whose EffectClass is 417.',
    },
    418: {
        name: 'Slot Amplify Effect 2',
        status: 'marker',
        wikiDesc: 'Same as blow 417, for slot 2.',
    },
    419: {
        name: 'Slot Amplify Effect 3',
        status: 'marker',
        wikiDesc: 'Same as blow 417, for slot 3.',
    },
    420: {
        name: 'Slot Amplify Effect 4',
        status: 'marker',
        wikiDesc: 'Same as blow 417, for slot 4.',
    },
};
